import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../keys'

export const chatApi = createApi({
    reducerPath: "chatApi",
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    tagTypes:['UserInChat'],
    endpoints: (builder) => ({
        getUsersInChat: builder.query({
            query: () => ({
                url: 'common/list-of-users-in-chat/',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem('livtoken')
                },
            }),
             providesTags: ['UserInChat'],
           
        }),
        openChat: builder.mutation({
            query: (data) => ({
                url: 'common/open-chat/',
                method: 'POST',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem('livtoken')
                },
                body: data
            }),
              invalidatesTags: ['UserInChat'],
        }),
        sendMessage: builder.mutation({
            query: (data) => ({
                url: 'common/send-message/',
                method: 'POST',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem('livtoken')
                },
                body: data
            })
        }),
        openProfile: builder.mutation({
            query: (data) => ({
                url: 'common/open-profile/',
                method: 'POST',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem('livtoken')
                },
                body: data
            })
        }),
        getSharedMedia: builder.query({
            query: ({ userId, pageNo }) => ({
                url: `common/shared-media/?user=${userId}&page_no=${pageNo}`,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem('livtoken')
                },
            })
        }),
updateBookingStatus:builder.mutation({
            query:(formData)=>({
                url:'common/update-booking-status',
                method:"POST",
                headers:{
                   Authorization: 'Bearer ' + localStorage.getItem('livtoken'),  
                },
                body:formData
            })
        }),

    //      freeBooking: builder.mutation({
    //   query: (data) => {
    //     const formData = new FormData();
    //     formData.append('category_id', data.category_id);
    //     formData.append('date', data.date);
    //     formData.append('time_slot', data.time_slot);
    //     formData.append('coach_id', data.coach_id);
    //     formData.append('plan_reservation_id', data.plan_reservation_id);

    //     return {
    //       url: 'client/book-free-consultation/',
    //       method: 'POST',
    //       body: formData,
    //       headers: {
    //         Authorization: "Bearer " + localStorage.getItem('livtoken')
    //       },
    //     };
    //   },
    
    // }),
    // invalidateTags:["UserInChat"]
    freeBooking: builder.mutation({
  query: (data) => {
    const formData = new FormData();
    formData.append('category_id', data.category_id);
    formData.append('date', data.date);
    formData.append('time_slot', data.time_slot);
    formData.append('coach_id', data.coach_id);
    formData.append('plan_reservation_id', data.plan_reservation_id);

    return {
      url: 'client/book-free-consultation/',
      method: 'POST',
      body: formData,
      headers: {
        Authorization: "Bearer " + localStorage.getItem('livtoken'),
      },
    };
  },
  invalidatesTags: ['UserInChat'],  // <--- add this here
}),
    })
})

export const {useFreeBookingMutation, useGetUsersInChatQuery, useOpenChatMutation, useSendMessageMutation, useOpenProfileMutation, useGetSharedMediaQuery,useUpdateBookingStatusMutation } = chatApi

